import icon1 from '@theme/profile-icon/small/1.svg'
import icon2 from '@theme/profile-icon/small/2.svg'
import icon3 from '@theme/profile-icon/small/3.svg'
import icon4 from '@theme/profile-icon/small/4.svg'
import icon5 from '@theme/profile-icon/small/5.svg'
import icon6 from '@theme/profile-icon/small/6.svg'
import icon7 from '@theme/profile-icon/small/7.png'

const profileIcons = {
  1: icon1,
  2: icon2,
  3: icon3,
  4: icon4,
  5: icon5,
  6: icon6,
  7: icon7,
}

export default profileIcons
